import { useRef, type ReactNode } from 'react';
import { Tooltip } from '@ics-portal/guardian';
import { HelpIcon } from '../../_atoms/icons';
import s from './HelpLink.module.scss';

interface HelpLinkProps {
    href: string;
}

export default function HelpLink({ href }: HelpLinkProps): ReactNode {
    const link = useRef(null);
    return (
        <>
            <Tooltip target={link}>Go to the help documentation page</Tooltip>
            <a
                ref={link}
                className={s.link}
                href={href}
                target="_blank"
                rel="help noreferrer"
            >
                <HelpIcon />
            </a>
        </>
    );
}
